const { getName } = require('country-list')

module.exports = function() {
  return function(value) {
    return value === value.toLowerCase() && !!getName(value)
  }
}
